// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__yMl4J","loader":"Loader_loader__s4N3W","rotation_19":"Loader_rotation_19__VFKYk","scale50":"Loader_scale50__rTzQu"};